export default __webpack_public_path__ + "14d321d9726e7ee9da44f16d14ddbc46.png";